import React from "react";
import "./PeerReviewerEvaluationApprovalForm.scss"
import PeerReviewerEvaluationApprovalForm from "../../features/PeerReviewerEvaluationApprovalForm/PeerReviewerEvaluationApprovalForm";
import { PeerReviewerContextProvider } from "../../features/PeerReviewerEvaluationApprovalForm/PeerReviewerContextConext";

const PeerReviewerEvaluationApproval = () => {
  return (
    <div className="page-container">
      <PeerReviewerContextProvider>
        <PeerReviewerEvaluationApprovalForm />
      </PeerReviewerContextProvider>
    </div >

  );
};
export default PeerReviewerEvaluationApproval;
